import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import EditImageSource from 'hb-builder/components/common/SettingsLibrary/CommonSettings/EditImageSource';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { EmailImageItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/emailImageItemAttributess';

import Link from './Link';

const Content = ({
  item,
  onChange,
}: Pick<
  ComponentSettingsTab<EmailImageItemAttributes>,
  'item' | 'onChange'
>) => {
  const settingProps = { item, onChange };

  return (
    <AccordionTitle
      data-testid="emailImage-content-settings"
      isInitiallyOpen
      title={__('Image')}
    >
      <EditImageSource hasImage={item.attributes?.imageSrc} id={item.id} />
      <TextSetting
        settingKey="attributes.imageAlt"
        title={__('Alternative text')}
        {...settingProps}
      />
      <Link {...settingProps} />
      <CheckboxSetting
        disabled={item.attributes?.imageLink?.startsWith('mailto:')}
        settingKey="imageLinkNewPage"
        title={__('Open link in a new tab')}
        {...settingProps}
      />
    </AccordionTitle>
  );
};

export default Content;
